import React, { Component } from 'react'
import './index.css'

class ForDevelopers extends Component {
  render() {
    return (
      <>
      <div className="maindiv3">
          <h1 className="headingdiv">
            Switch to a remote high-paying <br /> tech career with pesto{" "}
          </h1>
          <p className="paragraph">
            We help developers switch to global, remote, and high-paying
            careers.
            <br /> Find out how Pesto can help you{" "}
          </p>
          
        </div>
        <div className='lower-div2'>

        </div>
        {/*  */}
        <div className='div9'>
        <div className='div7'>
            <div>
              <img className='forcompantimg2' src='https://i.postimg.cc/Njb6Mh1k/638d6a87bea1f68013103d6e-Technical-Assesment.webp'/>
            </div>
            <div className='div8'>
              <h1 className='head4 bg'>Build your team</h1>
              <p className='para4 bg'>Hire pre-vetted, remote, full-time developers
                in half the time with time overlap, zero salary
                negotiations,or contracting issues.</p>
                <button className='btn btn-dark'>Start Hiring</button>
            </div>
        </div>
      </div>
        
      </>
    )
  }
}

export default ForDevelopers